import FallbackClassImg from "assets/fallback.png"
import styled from "styled-components"
import { StarFullIcon } from "ui/icons/StarFullIcon"
import { defaultThemeColors, themeFontSize } from "ui/theme"
import { getAvatarUrl, getLowestValidPrice } from "utils"
import { InstructorCardSkeleton } from "./InstructorCardSkeleton"

export const InstructorCard = ({ instructor, onClick }) => {
  if (!instructor) return <InstructorCardSkeleton />
  return (
    <Container onClick={onClick}>
      <ImageContainer>
        {instructor?.profile_pic || instructor?.user?.gallery[0]?.name ? (
          <Img
            src={getAvatarUrl(
              instructor.profile_pic || instructor?.user?.gallery[0]?.name
            )}
          />
        ) : (
          <Img src={FallbackClassImg} />
        )}
      </ImageContainer>
      <TextContainer>
        <TitleRow>
          <Username>{`${instructor?.user?.first_name || ""} ${instructor?.user?.last_name?.[0] || ""}.`}</Username>
          <RatingText>
            <StarFullIcon />
            <span>{Number(instructor?.rate || 0).toFixed(1)}</span>
          </RatingText>
        </TitleRow>
        <TitleText>{instructor?.subject_sub_category}</TitleText>
        <PriceText>
          {`from $${getLowestValidPrice(
            instructor?.type_of_class,
            instructor?.price_per_group_class,
            instructor?.price_per_private_class
          )} / person`}
        </PriceText>
        <SeeMoreText>See more</SeeMoreText>
      </TextContainer>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  cursor: pointer;
  padding-left: 20px;
  flex: 0 0 274px;
  padding-bottom: 8px;

`

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 4 / 4.2;
  border-radius: 16px;
  overflow: hidden;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
  background: #0000000d;
  transition: transform 0.4s ease;

  ${Container}:hover & {
    transform: scale(1.05);
  }
`

const TextContainer = styled.div`
  padding: 14px 2px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 1.5;
`

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

const Username = styled.p`
  font-size: 17px;
  font-weight: 500;
  color: ${defaultThemeColors.basicBlack};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
  margin: 0;
`

const TitleText = styled.p`
  font-size: 13px;
  font-weight: 300;
  color: #6b6b6b;
  line-height: 1.5;
  margin: 0;
`

const PriceText = styled.p`
  font-size: 13px;
  font-weight: 300;
  color: #6b6b6b;
  line-height: 1.5;
  margin: 0;
`

const RatingText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 400;
  color: ${defaultThemeColors.txt};

  & > svg {
    width: 12px;
    height: 12px;
    color: ${defaultThemeColors.orange};
  }
`

const SeeMoreText = styled.button`
  all: unset;
  font-size: ${themeFontSize("small")};
  font-weight: 600;
  color: ${defaultThemeColors.basicBlack};
  margin-top: 3px;
  cursor: pointer;
  line-height: 1.5;

  &:hover {
    color: ${defaultThemeColors.blue};
  }
`
